import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import FormData from "form-data";
import { toast, ToastContainer } from "react-toastify";
import Layout from "../../../components/Layout";

export default function AddGroup() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [surName, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [mandalDetailsId, setMandalDetailsId] = useState("");
  const [mandals, setMandals] = useState([]);
  const [selectedMandal, setSelectedMandal] = useState("");
  const location = useLocation();
  const currentPath = location?.pathname || "";

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SuperAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchMandals = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/MandalDetails/GetPublicList`
        );
        setMandals(response.data.data);
      } catch (error) {
        console.error("Error fetching mandals:", error);
      }
    };

    fetchMandals();
  }, []);

  // Handle change in select field
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedMandal(selectedValue);
    setMandalDetailsId(selectedValue); // Ensure MandalDetailsId is set correctly
  };

  const handleSubmit = async (e) => {
    setLoaded(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("MandalDetailsId", mandalDetailsId);
    formData.append("FirstName", firstName);
    formData.append("LastName", lastName);
    formData.append("surName", surName);
    formData.append("phone", phone);
    formData.append("IsVisible", true);

    try {
      const response = await axios.post(
        `${apiUrl}/SamparkEmploye/Create`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setLoaded(false);
      toast.success(response.data.message || "Group Added Successfully!");

      if (currentPath === "/add-group") {
        const timeOutId = setTimeout(() => {
          if (currentPath === "/add-group") {
            navigate("/manage-group");
          }
        }, 3000);
        return () => clearTimeout(timeOutId);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setLoaded(false);
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <Layout ac6="active">
        <section className="content-header pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">
                <h5>Add Group</h5>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/manage">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/manage-group">Group List</Link>
                  </li>
                  <li className="breadcrumb-item">Add Group</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* Mandal Selection */}
                  <div className="input-group mb-3">
                    <select
                      className="form-control"
                      style={{ cursor: "pointer" }}
                      required
                      id="mandalSelect"
                      value={selectedMandal} // Ensure this state is controlled
                      onChange={handleSelectChange}
                    >
                      <option value="" disabled>
                        Select Mandal
                      </option>
                      {mandals.map((mandal) => (
                        <option key={mandal.id} value={mandal.id}>
                          {mandal.name} ({mandal.description})
                        </option>
                      ))}
                    </select>
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-users"></span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="firstName">First Name</label>
                        <span className="text-danger">*</span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="middleName">Middle Name</label>
                        <span className="text-danger">*</span>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Middle Name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktSurname">Surname</label>
                        <span className="text-danger">*</span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Surname"
                          value={surName}
                          onChange={(e) => setSurname(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="phone">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Phone"
                          value={phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              setPhone(value);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="float-right">
                      <button
                        type="button"
                        className="btn btn-primary mx-2"
                        onClick={() => window.history.back()}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loaded}
                      >
                        {loaded ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading...
                          </>
                        ) : (
                          <>Submit</>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <ToastContainer position="top-center" style={{ width: "auto" }} />
      </Layout>
    </>
  );
}
